import {
  Component,
  Input,
  ViewChild,
  OnInit,
  AfterViewInit,
} from '@angular/core';
import { ResetPasswordFormComponent } from '@app/shared/components';
import { Router } from '@angular/router';
import { UserService } from '@app/core/services';
import { catchError, startWith, delay, map } from 'rxjs/operators';
import { EMPTY, of, Observable } from 'rxjs';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'ecp-reset-temp-password',
  templateUrl: './reset-temp-password.component.html',
  styleUrls: ['./reset-temp-password.component.scss'],
})
export class ResetTempPasswordComponent implements OnInit, AfterViewInit {
  @Input() email;
  @ViewChild(ResetPasswordFormComponent)
  resetPassword: ResetPasswordFormComponent;
  passwordValue: AbstractControl;
  validationList = [
    {
      message: 'Must have atleast 8 characters',
      regex: /.{8,}/,
      direction: true,
    },
    {
      message: 'Must include at least 1 number',
      regex: /[0-9]+/,
      direction: true,
    },
    {
      message: 'Must include at least 1 upper case letter',
      regex: /[A-Z]+/,
      direction: true,
    },
    {
      message: 'Must include at least 1 lower case letter',
      regex: /[a-z]+/,
      direction: true,
    },
    {
      message:
        'Must not include a sequence of three or more characters from your email address (before the @ symbol)',
      regex: '',
      direction: false,
    },
    {
      message: 'May include special characters (#, $, %, &, @, !, *)',
      regex: /.+/,
      direction: true,
    },
  ];

  isLoading: boolean;
  hasChanged: boolean;
  errors: Array<any> = [];
  isFocused: boolean;

  constructor(private router: Router, private userService: UserService) {}
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.passwordValue = this.resetPassword.password;
    });

    let emailSubstrings = [];
    let mainEmail = this.email.split('@')[0];
    // strip out special characters in the first part of the user's email
    const emailRegEx: RegExp = /[&\/\\#,+()$~%.'":*?<>{}]/g;
    mainEmail = mainEmail.toString().replace(emailRegEx, '');
    for (let i = 0; i < mainEmail.length; i++) {
      if (i + 3 > mainEmail.length) break;
      emailSubstrings.push('(' + mainEmail.slice(i, 3 + i) + ')');
    }

    this.validationList[4].regex = emailSubstrings.join('|');
  }
  ngOnInit(): void {
    localStorage.setItem('username_email', this.email);
  }

  handleSubmit(): boolean {
    this.isLoading = true;
    // define the payload we're sending to .NET
    const payload = {
      email: this.email,
      oldPassword: this.resetPassword.tempPassword.value,
      newPassword: this.resetPassword.password.value,
    };

    this.userService
      .resetPassword(payload)
      .pipe(
        catchError(err => {
          // for some reason the API is thrown as an error, but its a valid API call
          if (err.status === 200 || err === 'OK') {
            this.isLoading = false;
            this.hasChanged = true;
          } else {
            this.isLoading = false;
            this.errors = err.error.errorCauses;
            return EMPTY;
          }
        }),
      )
      .subscribe(response => {
        this.isLoading = false;
        this.hasChanged = true;
      });
    return false;
  }
  returnToLogin() {
    this.router.navigate(['/']);
  }
}
